module.exports = __webpack_public_path__ + "img/dl3_1.0715ef04.png";